/* eslint-disable */
// react
import React, { useState, useEffect } from 'react';
// shared component
// material component
import Popover from '@material-ui/core/Popover';
import { withStyles, Dialog } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import { HotKeys } from 'react-hotkeys';
import { useDispatch } from 'react-redux';
import {
  IPopMessage,
  IPopConfirm2,
  IPopConfirm3,
  IPopDialog,
} from './IPopDialog';
import { PopupTitle } from 'components/other/title/Title';
import { setLoadingRedux } from 'reducers/shareData/action';
import { ButtonContain, ButtonContainO } from '../Button';
import { StyledButtonConfirm, StyledButtonCancel } from '../StyledButton';
// react route

// redux

// selector
// css less sass
const Style = require('./PopDialog_style.module.css');
// kendo component

// presentational components

// container component

// other

// style -------------------------------------------------------------------------------------
const StyledPopover = withStyles({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  paper: {
    // width: "300px",
    maxWidth: 'none',
    top: 0,
    left: 0,
  },
})(Popover);

// style={{ zIndex: 100, background: "rgba(0, 0, 0, 0.4)",  }}
const StyleDialog = withStyles({
  paper: {
    maxWidth: 'none',
  },
})(Dialog);

// component -------------------------------------------------------------------------------------
const PopupEditTitle = (props: any) => {
  return (
    <div className={Style.listitem}>
      <PopupTitle title={props.title} />
      <IconButton
        style={{
          position: 'absolute',
          right: '12px',
          top: '0px',
          color: 'white',
        }}
        onClick={props.handleExit}
      >
        <CloseIcon />
      </IconButton>
    </div>
  );
};

const PopDialog = (props: IPopDialog) => {
  const {
    title = '系統訊息',
    width = '80vw',
    show,
    escExit = false,
    handleExit,
    children,
  } = props;
  return (
    <StyleDialog
      open={show}
      disableEnforceFocus={!escExit}
      onClose={escExit ? handleExit : undefined}
    >
      <PopupEditTitle title={title} handleExit={handleExit} />
      <div className={Style.popup_content} style={{ width, minWidth: 200 }}>
        {children}
      </div>
    </StyleDialog>
  );
};

export default PopDialog;

export const PopMessage = (props: IPopMessage) => {
  const dispatch = useDispatch();
  const {
    title = '系統訊息',
    width = '15vw',
    show,
    msg = '',
    handleExit,
    textColor,
    btnText = '關閉',
  } = props;
  const msgPresnt = msg!
    .split('\n')
    .map((obj, idx) => <div key={idx}>{obj}</div>);

  const funcWithLoading = (func: any) => () =>
    (async () => {
      dispatch(setLoadingRedux(true));
      await func();
      dispatch(setLoadingRedux(false));
    })();

  return (
    <HotKeys
      keyMap={{ KeyExit: ['Enter', 'Y', 'y'] }}
      handlers={{ KeyExit: funcWithLoading(handleExit) }}
    >
      <PopDialog
        show={show}
        title={title}
        handleExit={funcWithLoading(handleExit)}
        width={width}
        escExit
      >
        <div className={Style.text} style={{ color: textColor }}>
          {msgPresnt}
        </div>
        <div className={Style.function_button_area}>
          <ButtonContain
            className={Style.margin2}
            onClick={funcWithLoading(handleExit)}
          >
            {btnText}
          </ButtonContain>
        </div>
      </PopDialog>
    </HotKeys>
  );
};

export const PopConfirm2 = (props: IPopConfirm2) => {
  const dispatch = useDispatch();
  const {
    title = '系統訊息',
    width = '15vw',
    btnText = ['確認', '取消'],
    show,
    msg,
    handleConfirm,
    handleExit,
  } = props;

  const funcWithLoading = (func: any) => () =>
    (async () => {
      dispatch(setLoadingRedux(true));
      await func();
      dispatch(setLoadingRedux(false));
    })();

  return (
    <HotKeys
      keyMap={{
        KeyConfirm: ['Enter', 'Y', 'y'],
        KeyReject: ['N', 'n'],
      }}
      handlers={{
        KeyConfirm: funcWithLoading(handleConfirm),
        KeyReject: funcWithLoading(handleExit),
      }}
    >
      <PopDialog
        show={show}
        title={title}
        handleExit={funcWithLoading(handleExit)}
        width={width}
        escExit
      >
        <div className={Style.text}>{msg}</div>
        <div className={Style.function_button_area}>
          <ButtonContainO
            className={Style.margin2}
            variant="outlined"
            onClick={funcWithLoading(handleExit)}
          >
            {btnText[1]}
          </ButtonContainO>
          <ButtonContainO
            className={Style.margin2}
            onClick={funcWithLoading(handleConfirm)}
          >
            {btnText[0]}
          </ButtonContainO>
        </div>
      </PopDialog>
    </HotKeys>
  );
};

export const PopConfirm3 = (props: IPopConfirm3) => {
  const dispatch = useDispatch();
  const {
    title = '系統訊息',
    width = '25vw',
    show,
    msg = '',
    escExit,
    handleConfirm,
    handleReject,
    handleExit,
    btnText = ['是', '否', '取消'],
  } = props;
  const msgPresnt = msg!
    .split('\n')
    .map((obj, idx) => <div key={idx}>{obj}</div>);

  const funcWithLoading = (func: any) => () =>
    (async () => {
      dispatch(setLoadingRedux(true));
      await func();
      dispatch(setLoadingRedux(false));
    })();

  return (
    <HotKeys
      keyMap={{
        KeyConfirm: ['Y', 'y'],
        KeyReject: ['N', 'n'],
      }}
      handlers={{
        KeyConfirm: funcWithLoading(handleConfirm),
        KeyReject: funcWithLoading(handleReject),
      }}
    >
      <PopDialog
        show={show}
        title={title}
        handleExit={funcWithLoading(handleExit)}
        width={width}
        escExit
      >
        <div className={Style.text}>{msgPresnt}</div>
        <div className={Style.function_button_area}>
          <StyledButtonConfirm
            className={Style.margin2}
            onClick={funcWithLoading(handleConfirm)}
          >
            {btnText[0]}
          </StyledButtonConfirm>
          <StyledButtonConfirm
            className={Style.margin2}
            onClick={funcWithLoading(handleReject)}
          >
            {btnText[1]}
          </StyledButtonConfirm>
          <StyledButtonCancel
            className={Style.margin2}
            onClick={funcWithLoading(handleExit)}
          >
            {btnText[2]}
          </StyledButtonCancel>
        </div>
      </PopDialog>
    </HotKeys>
  );
};

// function ------------------------------------------------
export const PopObjToggle = (setConfig: any, show?: boolean) => {
  setConfig((prev: any) => ({
    ...prev,
    show: show === undefined ? !prev.show : show,
  }));
};
